import * as React from "react";
import { memo } from "react";
import { AppBar, Box, Container, Toolbar } from "@mui/material";
import { Link } from "react-router-dom";
import Logo from "../assets/img/logo.png";
import NavbarSearch from "./innerComponent/NavbarSearch";
import HandleUserLogin from "./HandleUserLogin";

const Navbar = memo(() => {
  return (
    <Container
      maxWidth="false"
      disableGutters
      sx={{
        px: { xs: 1, sm: 2, lg: 0 },
      }}
    >
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: "white.main",
          minHeight: { xs: 56, sm: 65 },
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          padding: { xs: "8px 0", sm: "8px 16px", lg: "5px 0" },
          width: "100%",
          boxShadow: 0,
          top: 0,
          px: { sm: 2, lg: 2 },
          borderRadius: 0,
        }}
      >
        <Toolbar
          disableGutters
          sx={{
            width: "100%",
            maxWidth: "false",
            mx: "auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: { xs: 1, sm: 2, lg: 0 },
          }}
        >
          <Link
            to="/"
            style={{
              textDecoration: "none",
              display: "flex",
              alignItems: "center",
            }}
            aria-label="Home"
          >
            <Box
              component="img"
              sx={{
                height: { xs: 48, sm: 60 },
                width: { xs: 96, sm: 120, md: 140 },
                objectFit: "cover",
                // objectFit: "contain",
                mr: { xs: 1, sm: 2, lg: 3 },
                mixBlendMode: "multiply",
                cursor: "pointer",
                transition: "transform 0.2s ease-in-out",
                "&:hover": {
                  transform: "scale(1.02)",
                },
              }}
              alt="99Gift Logo"
              src={Logo}
              loading="lazy"
            />
          </Link>

          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              width: {
                xs: "auto",
                sm: "100%",
                md: "60%",
                lg: "55vw",
                xl: "40vw",
              },
              minHeight: { xs: 40, sm: 45, lg: 49 },
              alignItems: "center",
              border: 1,
              borderColor: "lightSecondary.main",
              borderRadius: 1,
              backgroundColor: "white.main",
              "&:hover": {
                boxShadow: 1,
              },
              mx: { xs: 1, sm: 2 },
            }}
          >
            <NavbarSearch />
          </Box>

          <HandleUserLogin />
        </Toolbar>
      </AppBar>
    </Container>
  );
});

export default Navbar;